import React, { Fragment, useState, useEffect } from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
import HeroArt from '../../../assets/hero.png';
import Button from '../../ButtonComponent';
import { Section } from '../../Common/PageElement';
import { HeroBody, HeroBtns, HeroCol, HeroImage, HeroRow, HeroText, HeroTitle, Indicator, IndicatorField, Mouse } from './StyledHero';
import { useCookies } from 'react-cookie';
import '../../../pages/HomeBanner.css';
import {SERVER_PREFIX} from "../../../services/Config";
import {FeatureBody, FeatureIcon, FeatureItem, FeatureText, FeatureTitle} from "../Features/StyledFeatures";


const Hero = () => {
    const [cookies, setCookie] = useCookies(['firstTimeUser']);
    const [showBanner, setShowBanner] = useState(!cookies.firstTimeUser);

    const tutAddress = `${SERVER_PREFIX}/tutorial`
    // const faqAddress = `${SERVER_PREFIX}/tutorials`
    const handleCloseBanner = () => {
        setShowBanner(false);
        setCookie('firstTimeUser', false, { path: '/' });
    };




    const FunctionContent = [
        {
            title: "Search Annotation",
            text: `Find gene neighborhoods within a fixed-length window that contains target annotations within several seconds. 
            Currently supports KEGG, InterPro, and their member databases, with annotations based on GTDB r214.`
        },
        {
            title: "Upload Dataset",
            text: `Upload your own GenBank, GFF, or CSV file for visualization. 
            File format details can be found on the FAQ page.`
        },
        {
            title: "Semantic Analysis",
            text: `Trained the Word2Vec model on genes with protein function annotations (Pfam) 
            to explore genes that share similar function annotations in neighborhoods, 
            revealing potential functional similarities.`
        },
        {
            title: "Examples",
            text: `Example visualizations for different case studies.`
        },
    ]


    return (
        <>
            <Section id="hero" height="above_full" center>
                <Container style={{ paddingTop: "60px" }}>
                    <Fade left duration={1000} delay={600} distance="30px">
                        {showBanner && (
                            <div>
                                <div className="banner" style={{opacity: 1, transform: 'translateY(0)'}}>
                                    Welcome to AnnoView! First time user? Take a look at our&nbsp;
                                    <a href={tutAddress}
                                       style={{color: 'white', textDecoration: 'underline', fontWeight: '500'}}>tutorial
                                        page</a>.
                                    <button
                                        onClick={handleCloseBanner}
                                        className="bannerCloseButton"
                                    >
                                        &times;
                                    </button>
                                </div>
                                <div className="banner" style={{opacity: 1, transform: 'translateY(0)'}}>
                                    'Search GTDB' is now removed, try 'Search Annotation' for
                                    one or more protein with existing annotations.
                                    <button
                                        onClick={handleCloseBanner}
                                        className="bannerCloseButton"
                                    >
                                        &times;
                                    </button>
                                </div>
                            </div>


                        )}
                    </Fade>

                    <HeroRow>
                        <HeroCol lg={6} md={12}>
                            <Fade left duration={1000} delay={600} distance="30px">
                                <HeroBody>
                                    <HeroTitle>Gene Neighborhood Browser</HeroTitle>
                                    <HeroText>
                                        AnnoView is an online tool for genome visualization and exploration of gene
                                        neighborhoods.
                                        AnnoView facilitates visualization of related gene neighborhoods across hundreds of species, clusters neighborhoods
                                        based on gene composition, locates genes or functions of interest, and colors genes by custom or pre-computed
                                        metadata.
                                        <br />
                                        Upload your own genomic regions (.gbk, .gff, or .csv files) and custom metadata (e.g., gene annotations), or explore
                                        subsets of genomic regions from the
                                        <a style={{color:"blue","textDecoration": "underline"}} href="http://annoviewv2.uwaterloo.ca/annotree"> AnnoTree </a>
                                        database, drawing from over 80,000 bacterial and 4,400 archaeal
                                        genomes. Then, customize your plots and export them as publication-quality images.
                                    </HeroText>
                                </HeroBody>
                            </Fade>
                        </HeroCol>
                        <HeroCol>
                            <Fade right duration={1000} delay={600} distance="30px">
                                <HeroImage alt="hero_art" src={HeroArt} />
                            </Fade>
                        </HeroCol>
                    </HeroRow>
                    <HeroRow>
                        <HeroCol>
                            <Fade top duration={1000} delay={600} distance="30px">
                                <Row xs={1} md={2} className="g-4">
                                    <Col key={0}>
                                        <FeatureItem>

                                            <FeatureIcon><i className="fas fa-solid fa-fire fa-3x"
                                                            style={{"color": "#ee1111"}}></i></FeatureIcon>
                                            <FeatureBody>
                                                <FeatureTitle>
                                                    <Link to="/annotool_search">
                                                        <Button fill={true}>Search Annotation</Button>
                                                    </Link>
                                                </FeatureTitle>

                                                <FeatureText>{FunctionContent[0].text}</FeatureText>
                                            </FeatureBody>

                                        </FeatureItem>
                                    </Col>

                                    <Col key={1}>
                                        <FeatureItem>

                                            {/*<FeatureIcon><i className="fas fa-solid fa-arrow-right fa-2x"*/}
                                            {/*                style={{"color": "#2f8ae1"}}></i></FeatureIcon>*/}
                                            <FeatureIcon></FeatureIcon>
                                            <FeatureBody>
                                                <FeatureTitle>
                                                    <Link to="upload">
                                                        <Button>Upload Dataset</Button>
                                                    </Link>
                                                </FeatureTitle>

                                                <FeatureText>{FunctionContent[1].text}</FeatureText>
                                            </FeatureBody>

                                        </FeatureItem>
                                    </Col>

                                    <Col key={2}>
                                        <FeatureItem>

                                            <FeatureIcon></FeatureIcon>
                                            <FeatureBody>
                                                <FeatureTitle>
                                                <Link to="/model">
                                                        <Button fill={true}>Semantic analysis </Button>
                                                    </Link>
                                                </FeatureTitle>

                                                <FeatureText>{FunctionContent[2].text}</FeatureText>
                                            </FeatureBody>

                                        </FeatureItem>
                                    </Col>


                                    <Col key={3}>
                                        <FeatureItem>

                                            <FeatureIcon></FeatureIcon>
                                            <FeatureBody>
                                                <FeatureTitle>
                                                <Link to="/examples">
                                                        <Button fill={true}>Examples</Button>
                                                    </Link>
                                                </FeatureTitle>

                                                <FeatureText>{FunctionContent[3].text}</FeatureText>
                                            </FeatureBody>

                                        </FeatureItem>
                                    </Col>

                                </Row>

                            {/*    <HeroBtns>*/}
                            {/*        <Link to="upload">*/}
                            {/*            <Button>Upload Dataset</Button>*/}
                            {/*        </Link>*/}
                            {/*        /!*<Link to="/annotree_search">*!/*/}
                            {/*        /!*    /!*<Button>Annotree Search</Button>*!/*!/*/}
                            {/*        /!*    <Button>Search GTDB</Button>*!/*/}
                            {/*        /!*</Link>*!/*/}
                            {/*        <Link to="/annotool_search">*/}
                            {/*            <Button fill={true}>Search Annotation</Button>*/}
                            {/*        </Link>*/}
                            {/*        <Link to="/model">*/}
                            {/*            <Button fill={true}>Semantic analysis </Button>*/}
                            {/*        </Link>*/}
                            {/*        <Link to="/examples">*/}
                            {/*            <Button fill={true}>Examples</Button>*/}
                            {/*        </Link>*/}

                            {/*</HeroBtns>*/}
                        </Fade>
                    </HeroCol>
                </HeroRow>
            </Container>
        </Section>
        </>
    )
}

export default Hero